/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * IS_NOT_NULL operator looks for values that are not null.
 */
export interface IsNotNullResourceId {}
